"use strict";
require("../modules/es.promise.constructor");
require("../modules/es.promise.all");
require("../modules/es.promise.catch");
require("../modules/es.promise.race");
require("../modules/es.promise.reject");
require("../modules/es.promise.resolve");
